import React from "react";

export function EqBars({ playing = true, className = "" }) {
  return (
    <div className={`eq-bars ${playing ? "" : "paused"} ${className}`} aria-hidden>
      {Array.from({ length: 10 }).map((_, i) => <span key={i} />)}
    </div>
  );
}
